module.exports = __webpack_public_path__ + "img/lab_birthday-768x1024.c1bc0afd.jpeg";